<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 注册 -->
      <div class="right">
        <p class="name">注册</p>
        <template>
          <div class="info" v-if="accountType">
            您好，{{ userName }} <br />邮件验证码已发送成功，请登录邮箱查收邮件进行确认操作
          </div>
          <div class="info" v-else>您好，{{ userName }} <br />验证短信已发送成功，请输入手机验证码进行确认操作</div>
        </template>
        <div class="form">
          <!-- 邮箱账号 -->
          <template v-if="accountType">
            <el-input
              class="mailbox"
              v-model="authCode"
              @input="changeStatus"
              placeholder="请输入验证码"
              maxlength="10"
            />
            <div class="agreement">
              <template v-if="vertifySendStatus"> 没有收到？<span @click="sendAgain">重新发送</span> </template>
              <template v-else>
                <span>{{ vertifyCodeTime }}s</span>后可重新发送
              </template>
            </div>
          </template>
          <!-- 手机账号 -->
          <template v-else>
            <el-input
              class="mailbox"
              v-model="authCode"
              placeholder="请输入验证码"
              maxlength="10"
              @input="changeStatus"
            >
              <template slot="append">
                <div v-if="vertifySendStatus" @click="sendAgain">重新发送</div>
                <div v-else>{{ vertifyCodeTime }}s</div>
              </template>
            </el-input>
          </template>

          <el-button :class="[!btnStatus ? 'btn-status' : '', 'btn']" type="primary" @click="btnStatus ? goNext() : ''"
            >下一步</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftImg from '@login/components/leftImg';
import { mapActions } from 'vuex';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      accountType: 1, // 账号类型标识：1为邮箱地址，0为手机号
      userName: '', // 账号
      vertifySendStatus: 1, // 验证码发送状态 0: 不可重新发送 1: 可重新发送
      vertifyCodeTime: 60, // 重新发送计时
      timer: null, // 计时器
      authKey: '', // 验证码返回唯一标识
      authCode: '', // 验证码
      btnStatus: false, //按钮可点击状态
    };
  },
  mounted() {
    this.checkAccountType();
  },
  methods: {
    ...mapActions('login', [
      'checkAccountRegistered',
      'getEmailVerifyCode',
      'getPhoneVerifyCode',
      'checkPhoneVerifyCode',
      'checkEmailVerifyCode',
    ]),

    // 判断账号类型
    checkAccountType() {
      const { emailAccount, phoneAccount } = this.$route.query;
      if (emailAccount) {
        this.userName = emailAccount;
        this.accountType = 1;
      } else if (phoneAccount) {
        this.userName = phoneAccount;
        this.accountType = 0;
      }
    },

    // 发送验证码
    async sendAgain() {
      try {
        this.vertifySendStatus = 0;
        if (this.accountType === 1) {
          // 发送邮箱验证码
          this.authKey = await this.getEmailVerifyCode({ account: this.userName });
          this.handleVertifyTimeChange();
        } else if (this.accountType === 0) {
          // 发送手机验证码
          this.authKey = await this.getPhoneVerifyCode({ account: this.userName });
          this.handleVertifyTimeChange();
        }
      } catch (error) {
        this.vertifySendStatus = 1;
        console.error(error);
      }
    },

    // 验证码倒计时
    handleVertifyTimeChange() {
      this.timer = setInterval(() => {
        this.vertifyCodeTime -= 1;
        if (this.vertifyCodeTime <= 0) {
          this.vertifySendStatus = 1;
          this.vertifyCodeTime = 60;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 修改邮箱/协议选中状态
    changeStatus() {
      if (this.authCode != '') {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },

    // 跳转下一步
    async goNext() {
      const { authCode, userName } = this;
      let checkRes = ''; // 校验结果
      if (this.accountType === 1) {
        // 邮箱账号校验
        const authKey = this.authKey || localStorage.getItem('EMAIL_AK');
        checkRes = await this.checkEmailVerifyCode({ authCode, authKey, mailAddress: userName });
      } else if (this.accountType === 0) {
        // 手机账号校验
        const authKey = this.authKey || localStorage.getItem('PHONE_AK');
        checkRes = await this.checkPhoneVerifyCode({ authCode, authKey, phoneNum: userName });
      }
      if (checkRes === 'success') {
        this.removeAuthKey();
        this.$router.push({
          name: 'forget-Three',
          params: { userAccount: this.userName },
        });
        return;
      }
      // 验证失败
      this.$message.error('请输入正确的验证码');
    },

    // 删除缓存的验证信息数据
    removeAuthKey() {
      try {
        localStorage.removeItem('PHONE_AK');
        localStorage.removeItem('EMAIL_AK');
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
  }
  .info {
    width: 330px;
    height: 69px;
    background: #dff7df;
    font-size: 14px;
    line-height: 24px;
    margin: auto;
    padding: 15px;
  }
  .form {
    text-align: center;
    /deep/.el-input-group__append {
      width: 95px;
      background: #4359b7;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }
  .mailbox {
    width: 360px;
    margin: 15px 0;
  }
  .agreement {
    font-size: 12px;
    color: #333;
    text-align: left;
    margin-left: 20px;
    span {
      color: #4359b7;
      cursor: pointer;
    }
  }
  .btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
    margin: 20px 0;
  }
  .btn-status {
    opacity: 0.4;
  }
  .back {
    font-size: 14px;
    color: #666;
    span:nth-child(2) {
      color: #4359b7;
      cursor: pointer;
    }
  }
}
</style>
